const theme = {
  colors: {
    bg: '#2e3842',
    fg: '#fff',
    fgBold: '#fff',
    fgLight: 'rgba(255,255,255,0.5)',
    border: '#fff',
    borderBg: 'rgba(144,144,144,0.25)',
    border2: '#fff',
    border2Bg: 'rgba(144,144,144,0.5)',

    accent1: {
      bg: '#21b2a6',
      fgBold: '#ffffff',
      fg: '#bfdfd9',
      fgLight: '#99d1c8',
      border: 'rgba(0,0,0,0.125)',
      borderBg: 'rgba(255,255,255,0.075)',
      border2: 'rgba(0,0,0,0.25)',
      border2Bg: 'rgba(255,255,255,0.2)',
    },

    accent2: {
      bg: '#00ffcc',
      fgBold: '#ffffff',
      fg: '#bffff2',
      fgLight: '#99ffe8',
      border: 'rgba(0,0,0,0.125)',
      borderBg: 'rgba(255,255,255,0.075)',
      border2: 'rgba(0,0,0,0.25)',
      border2Bg: 'rgba(255,255,255,0.2)',
    },

    accent3: {
      bg: '#00f0ff',
      fgBold: '#ffffff',
      fg: '#bffbff',
      fgLight: '#99f7ff',
      border: 'rgba(0,0,0,0.125)',
      borderBg: 'rgba(255,255,255,0.075)',
      border2: 'rgba(0,0,0,0.25)',
      border2Bg: 'rgba(255,255,255,0.2)',
    },

    accent4: {
      bg: '#76ddff',
      fgBold: '#ffffff',
      fg: '#d9f4ff',
      fgLight: '#c3eeff',
      border: 'rgba(0,0,0,0.125)',
      borderBg: 'rgba(255,255,255,0.075)',
      border2: 'rgba(0,0,0,0.25)',
      border2Bg: 'rgba(255,255,255,0.2)',
    },

    accent5: {
      bg: '#505393',
      fgBold: '#ffffff',
      fg: '#d3d4e4',
      fgLight: '#b8b9d3',
      border: 'rgba(0,0,0,0.125)',
      borderBg: 'rgba(255,255,255,0.075)',
      border2: 'rgba(0,0,0,0.25)',
      border2Bg: 'rgba(255,255,255,0.2)',
    },

    accent6: {
      bg: '#ed4933',
      fgBold: '#ffffff',
      fg: '#fbd2cc',
      fgLight: '#f8b7ae',
      border: 'rgba(0,0,0,0.125)',
      borderBg: 'rgba(255,255,255,0.075)',
      border2: 'rgba(0,0,0,0.25)',
      border2Bg: 'rgba(255,255,255,0.2)',
    },

    accent7: {
      bg: '#ffffff',
      fgBold: '#2E3842',
      fg: '#4E4852',
      fgLight: '#8E8892',
      border: '#dfdfdf',
      borderBg: 'rgba(0,0,0,0.0375)',
      border2: '#bfbfbf',
      border2Bg: 'rgba(0,0,0,0.1)',
    },
  },

  fonts: {
    family: "'Open Sans', Helvetica, sans-serif",
    familyFixed: "'Courier New', monospace",
    weight: 400,
    weightBold: 600,
    weightExtrabold: 800,
  },

  size: {
    elementHeight: '2.75em',
    elementMargin: '2em',
    letterSpacing: '0.075em',
    letterSpacingAlt: '0.225em',
  },

  duration: {
    transitions: '0.2s',
    menu: '0.5s',
    fadein: '3s',
  },

  breakpoints: {
    xlarge: '1680px',
    large: '1280px',
    medium: '980px',
    small: '736px',
    xsmall: '480px',
  },

  misc: {
    zIndexBase: 10000,
  },
};

export default theme;
